import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1324709679169511';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: unknown;
  }
}
/**
 * Injects the official Meta Pixel snippet on mount and tracks the initial PageView.
 * Rendered once at the app root. In Magic Patterns we cannot edit index.html,
 * so the pixel is bootstrapped from here instead.
 */
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return; // avoid double-init on re-mounts
    (function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        ;
        (b.head || b.documentElement).appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq?.('init', PIXEL_ID);
    window.fbq?.('track', 'PageView');
  }, []);
  return <noscript data-id="element-200" data-mp="1dh7egk6jd5ik">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-201" data-mp="1reckwla5w6ec" />
    </noscript>;
}
/** Fire a Meta Pixel event from anywhere (e.g. checkout buttons). */
export function trackPixel(event: string, params?: Record<string, unknown>) {
  window.fbq?.('track', event, params);
}